"use strict";

/* const PROTOCOL = "http";
const DOMAIN = "172.17.0.1";
const PORT = ":8080";
 */

// const PROTOCOL = "https";
// const DOMAIN = "rocola.pendulo.com.mx";
// const PORT = "";

const PROTOCOL = "https";
const DOMAIN = "rocolapendulo.com";
const PORT = "";


const BASE_URL = `${PROTOCOL}://${DOMAIN}${PORT}/consola/controllers/controller_musica.php`;

const ID_SUCURSAL = getIdSucursal(window.location.search.substring(1));

console.log("ID SUCURSAL -->   ", ID_SUCURSAL);

function getIdSucursal(idSucursal) {
  let sucursales = {
    condesa: 11,
    polanco: 12,
    santafe: 13,
    perisur: 14,
    zonarosa: 15,
    roma: 16,
    sanangel: 17,
    delvalle: 18,
    prueba: 20,
  };

  console.log("SUCURSAL:   ", sucursales[idSucursal]);

  return sucursales[idSucursal];
}

export { BASE_URL, ID_SUCURSAL };
